<img *ngIf="currentIndex === 0" [src]="currentImage" class="object-cover fade-in transition-opacity" alt="Carousel image" />
<img *ngIf="currentIndex === 1" [src]="currentImage" class="object-cover fade-in transition-opacity" alt="Carousel image" />
<img *ngIf="currentIndex === 2" [src]="currentImage" class="object-cover fade-in transition-opacity" alt="Carousel image" />
